import { Tabs, TabsProps } from '@material-ui/core';
import React from 'react';
import styles from './SGSTabs.module.scss';

type Props = Omit<TabsProps, 'onChange'> & {
    onChange?:
        | ((event: React.ChangeEvent<{}>, value: any) => void)
        | ((event: React.FormEvent<HTMLButtonElement>) => void);
};

const SGSTabs: React.FC<Props> = ({ ...props }) => {
    return <Tabs {...props} classes={{ root: styles.tabs, indicator: styles.indicator }} disableRipple />;
};

export default SGSTabs;
